<div class="nova-container" (click)="onNovaContainerClick($event)">

  <!-- Left side: History - always in DOM to avoid disappearing when query is sent (panel visibility is via width) -->
  <div class="nova-left-panel"
       [class.history-open]="isHistoryOpen$ | async"
       [class.history-closed]="!(isHistoryOpen$ | async)"
       (click)="$event.stopPropagation()">
    <app-nova-history
      [conversations]="(conversations$ | async) || []"
      [currentConversation]="currentConversation$ | async"
      [showSavedFiles]="showSavedFiles"
      (conversationSelected)="selectConversation($event)"
      (conversationRenamed)="saveConversationTitle($event.id, $event.title)"
      (conversationDeleted)="confirmDeleteConversation($event)"
      (savedFilesClicked)="onSavedFilesClicked()">
    </app-nova-history>
  </div>

  <!-- Right side: Topbar + Content -->
  <div class="nova-right-panel" (click)="$event.stopPropagation()">
    <div class="topbar" (click)="$event.stopPropagation()">
      <!-- <div class="preview-tag">PREVIEW</div> -->
      <button (click)="startNewConversation()" title="New conversation">
        <img src="assets/icons/navigator/new-chat.svg" alt="new-chat-btn">
      </button>
      <button (click)="closeNova(); $event.stopPropagation()" title="Close">
        <img src="assets/icons/navigator/cross-icon.svg" alt="close-btn">
      </button>
    </div>

    <div class="nova-content">
      <div class="nova-without-history"
           [class.history-open]="isHistoryOpen$ | async"
           [class.history-closed]="!(isHistoryOpen$ | async)">
          <div class="nova-header-section">
            <div class="left-section-wrapper" *ngIf="!(isHistoryOpen$ | async)">
              <div class="left-section">
                <img src="assets/icons/navigator/nova-header-icon.svg" alt="nova-icon" (click)="openNovaHistory()">
                <span>Nova</span>
              </div>

              <div class="left-section-hover">
                <img src="assets/icons/navigator/toggle-icon.svg" alt="nova-icon" (click)="openNovaHistory()">
                <span>Nova</span>
              </div>
            </div>

          </div>

        <div class="nova-main-section">

          <!-- Show Saved Files (nova-storage) when selected -->
          <app-nova-storage *ngIf="showSavedFiles"></app-nova-storage>

          <!-- Show conversations when Saved Files is not selected -->
          <div *ngIf="!showSavedFiles">
            <div class="output-container">
              <!-- Show chat messages when there are messages in the conversation -->
              <div class="chat-section" *ngIf="shouldShowChatMessages()">
                <div class="messages-container" #messagesContainer>
                  <ng-container *ngFor="let group of getGroupedMessages(); trackBy: trackByGroupDate">
                    <div class="date-separator">
                      <span>{{ formatDateForDisplay(group.date) }}</span>
                    </div>

                    <div
                      *ngFor="let message of group.messages; trackBy: trackByMessageId"
                      class="message-item"
                      [class.user-message]="message.isUser"
                      [class.nova-message]="!message.isUser">
                    <div class="message-content">
                      <div class="message-text">
                          <img class="nova-vector-icon" src="assets/icons/navigator/nova-vector.svg" alt="" *ngIf="!message.isUser">
                        <div class="message-content-wrapper">
                          <!-- Summary (main response text) -->
                          <div class="response-summary" [class.has-details]="!message.isUser && hasResponseDetails(message)">
                            <span *ngIf="!hasMarkdown(getMessageDisplayText(message))">{{ getMessageDisplayText(message) }}</span>
                            <span *ngIf="hasMarkdown(getMessageDisplayText(message))" [innerHTML]="parseMarkdown(getMessageDisplayText(message))"></span>
                          </div>

                          <!-- TEXT_ANALYSIS_OVERFLOW action buttons -->
                          <div class="overflow-action-buttons" *ngIf="isTextAnalysisOverflow(message)">
                            <button type="button" class="overflow-btn overflow-btn-sample"
                              [disabled]="!isLastOverflowMessage(message)"
                              [class.overflow-btn-disabled]="!isLastOverflowMessage(message)"
                              (click)="sendOverflowReply('sample')">
                              Sample
                            </button>
                            <button type="button" class="overflow-btn overflow-btn-filters"
                              [disabled]="!isLastOverflowMessage(message)"
                              [class.overflow-btn-disabled]="!isLastOverflowMessage(message)"
                              (click)="sendOverflowReply('change_filters')">
                              Change Filter
                            </button>
                          </div>

                          <!-- Filter confirmation chips -->
                          <ng-container *ngIf="getFilterConfirmCandidates(message) as filterCandidates">
                            <div class="filter-confirm-panel" *ngIf="filterCandidates.length > 0">
                              <div class="filter-confirm-hint">Select the field interpretations to apply, then confirm.</div>
                              <div class="filter-confirm-chips">
                                <div
                                  class="filter-confirm-chip"
                                  *ngFor="let candidate of filterCandidates; trackBy: trackByFilterCandidate"
                                  [class.selected]="isFilterCandidateSelected(message, candidate)"
                                  [class.disabled]="!isLastFilterConfirmMessage(message)"
                                  role="checkbox"
                                  [attr.aria-checked]="isFilterCandidateSelected(message, candidate)"
                                  [attr.aria-disabled]="!isLastFilterConfirmMessage(message)"
                                  (click)="toggleFilterCandidate(message, candidate)">
                                  <input
                                    type="checkbox"
                                    class="filter-confirm-checkbox"
                                    tabindex="-1"
                                    [checked]="isFilterCandidateSelected(message, candidate)"
                                    [disabled]="!isLastFilterConfirmMessage(message)">
                                  <span class="filter-confirm-chip-label">{{ getFilterCandidateLabel(candidate) }}</span>
                                  <span class="filter-confirm-chip-tooltip" *ngIf="getFilterCandidateTooltipField(candidate) || candidate.definition" role="tooltip">
                                    <strong *ngIf="getFilterCandidateTooltipField(candidate)">{{ getFilterCandidateTooltipField(candidate) }}</strong><ng-container *ngIf="candidate.definition">{{ getFilterCandidateTooltipField(candidate) ? ' : ' : '' }}{{ candidate.definition }}</ng-container>
                                  </span>
                                </div>
                              </div>
                              <button
                                type="button"
                                class="filter-confirm-submit"
                                [disabled]="!hasFilterSelection(message) || !isLastFilterConfirmMessage(message)"
                                (click)="submitFilterSelection(message)">
                                Confirm
                              </button>
                            </div>
                          </ng-container>

                          <!-- Structured response details: charts, files, tables, filters (system messages only) -->
                          <div class="response-details" *ngIf="!message.isUser && hasResponseDetails(message)">
                            <!-- <div class="response-details-heading">Response details</div> -->
                            <!-- Charts and files -->
                            <div class="message-attachments" *ngIf="message.attachments && message.attachments.length > 0">
                            <ng-container *ngFor="let attachment of message.attachments; let i = index; trackBy: trackByAttachmentId">
                              <!-- Regular file attachments -->
                              <div class="attachment-item" *ngIf="!isImageFile(attachment) && !isHtmlFile(attachment)"
                                   (dblclick)="onAttachmentClick(attachment)">
                                <div class="file-icon">
                                  <img [src]="getFileIcon(attachment)" alt="file">
                                </div>
                                <span class="file-name">
                                  <span class="file-name-base">{{ getFileNameWithoutExtension(attachment.name) }}</span>
                                  <span class="file-extension">{{ getFileExtension(attachment.name) }}</span>
                                </span>
                                <div class="attachment-actions">
                                  <button class="three-dot-btn" (click)="toggleAttachmentMenu(message.id, i, $event)" title="More options">
                                    <img src="assets/icons/navigator/more-vert.svg" alt="more options">
                                  </button>
                                  <div class="attachment-menu" *ngIf="showAttachmentMenu === message.id + '_' + i" [attr.data-menu-id]="message.id + '_' + i" (click)="$event.stopPropagation()">
                                    <div class="menu-item" (click)="saveToFiles(attachment)">
                                      <img src="assets/icons/navigator/save-to-file.svg" alt="files">
                                      <span>Save to Files</span>
                                    </div>
                                    <div class="menu-item" (click)="downloadFile(attachment)">
                                      <img src="assets/icons/navigator/file_download.svg" alt="download">
                                      <span>Download</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!-- HTML file attachments (charts) - displayed as JPEG or iframe fallback; title comes from thumbnail -->
                              <div class="attachment-item html-attachment" *ngIf="isHtmlFile(attachment)" (dblclick)="openImageViewer(attachment)">
                                <!-- Chart image container -->
                                <div class="chart-image-container" [class.loading]="isImageLoading(attachment)">
                                  <!-- Loading indicator -->
                                  <div class="chart-loading" *ngIf="isImageLoading(attachment)">
                                    <div class="loading-spinner"></div>
                                    <span>Generating chart...</span>
                                  </div>

                                  <!-- Chart image: prefer API thumbnail, else client-generated JPEG -->
                                  <img
                                    *ngIf="getChartDisplayUrl(attachment) && !isImageLoading(attachment) && !hasConversionError(attachment)"
                                    [src]="getChartDisplayUrl(attachment)"
                                    [alt]="attachment.name"
                                    class="chart-image"
                                    (error)="onChartThumbnailImgError(attachment)">

                                  <div
                                    class="attachment-unavailable"
                                    *ngIf="isAttachmentPresignedExpired(attachment) && !isImageLoading(attachment)">
                                    {{ fileUnavailableMessage }}
                                  </div>

                                  <!-- Fallback iframe if no thumbnail/JPEG or conversion failed -->
                                  <iframe
                                    *ngIf="(!getChartDisplayUrl(attachment) || hasConversionError(attachment)) && !isImageLoading(attachment) && !isAttachmentPresignedExpired(attachment)"
                                    [src]="getSafeUrl(attachment.url)"
                                    class="chart-iframe"
                                    (load)="removePlotlyToolbarFromIframe($event, attachment)">
                                  </iframe>
                                </div>

                                <!-- Chart description from API (markdown) - shown below the chart -->
                                <div class="chart-description" *ngIf="attachment.chartDescription" [innerHTML]="parseMarkdown(attachment.chartDescription)"></div>

                                <div class="attachment-actions">
                                  <button class="three-dot-btn" (click)="toggleAttachmentMenu(message.id, i, $event)" title="More options">
                                    <img src="assets/icons/navigator/more-vert.svg" alt="more options">
                                  </button>
                                  <div class="attachment-menu" *ngIf="showAttachmentMenu === message.id + '_' + i" (click)="$event.stopPropagation()">
                                    <div class="menu-item" (click)="saveToFiles(attachment)">
                                      <img src="assets/icons/navigator/save-to-file.svg" alt="save to files">
                                      <span>Save to Files</span>
                                    </div>
                                    <div class="menu-item" (click)="downloadFile(attachment)">
                                      <img src="assets/icons/navigator/file_download.svg" alt="download">
                                      <span>Download</span>
                                    </div>
                                    <div class="menu-item" *ngIf="attachment.step"
                                         [class.disabled]="isSectionDownloading(message.id, attachment.step)"
                                         (click)="downloadSectionData(message, attachment.step, attachment.name)">
                                      <img src="assets/icons/navigator/file_download.svg" alt="download data">
                                      <span>{{ isSectionDownloading(message.id, attachment.step) ? 'Preparing…' : 'Download data' }}</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!-- Image attachments -->
                              <div class="attachment-item image-attachment"
                                   *ngIf="isImageFile(attachment)"
                                   (dblclick)="openImageViewer(attachment)">
                                <div class="image-preview">
                                  <img [src]="attachment.url" [alt]="attachment.name" class="preview-image" (error)="onImageAttachmentPreviewError(attachment)">
                                  <div class="image-overlay">
                                    <img src="assets/icons/unfold_more.svg" alt="expand" class="expand-icon">
                                  </div>
                                </div>
                                <div class="attachment-actions">
                                  <button class="three-dot-btn" (click)="toggleAttachmentMenu(message.id, i, $event)" title="More options">
                                    <img src="assets/icons/navigator/more-vert.svg" alt="more options">
                                  </button>
                                  <div class="attachment-menu" *ngIf="showAttachmentMenu === message.id + '_' + i" (click)="$event.stopPropagation()">
                                    <div class="menu-item" (click)="saveToFiles(attachment)">
                                      <img src="assets/icons/navigator/save-to-file.svg" alt="save to files">
                                      <span>Save to Files</span>
                                    </div>
                                    <div class="menu-item" (click)="downloadFile(attachment)">
                                      <img src="assets/icons/navigator/file_download.svg" alt="download">
                                      <span>Download</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </ng-container>
                          </div>

                          <!-- Tables from response metadata (system messages only) -->
                          <div class="response-data-section tables-section" *ngIf="!message.isUser && message.tables && message.tables.length > 0">
                            <div class="section-label">Tables</div>
                            <div class="table-block" *ngFor="let table of message.tables; let ti = index">
                              <!-- Overflow menu (Download data) -->
                              <div class="attachment-actions table-actions" *ngIf="table.step">
                                <button class="three-dot-btn" (click)="toggleTableMenu(message.id, ti, $event)" title="More options">
                                  <img src="assets/icons/navigator/more-vert.svg" alt="more options">
                                </button>
                                <div class="attachment-menu" *ngIf="showAttachmentMenu === 'table_' + message.id + '_' + ti" (click)="$event.stopPropagation()">
                                  <div class="menu-item"
                                       [class.disabled]="isSectionDownloading(message.id, table.step)"
                                       (click)="downloadSectionData(message, table.step, table.table_title)">
                                    <img src="assets/icons/navigator/file_download.svg" alt="download data">
                                    <span>{{ isSectionDownloading(message.id, table.step) ? 'Preparing…' : 'Download data' }}</span>
                                  </div>
                                </div>
                              </div>
                              <div class="table-title" *ngIf="table.table_title">{{ table.table_title }}</div>
                              <div class="table-description" *ngIf="table.table_description" [innerHTML]="parseMarkdown(table.table_description)"></div>
                              <div class="table-content" *ngIf="table.table_content" [innerHTML]="parseMarkdown(table.table_content)"></div>
                            </div>
                          </div>

                          <!-- Filters applied (system messages only) -->
                          <div class="response-data-section filters-section" *ngIf="!message.isUser && message.filtersApplied && message.filtersApplied.length > 0">
                            <div class="section-label">Filters applied</div>
                            <div class="filter-chips">
                              <div class="filter-chip" *ngFor="let f of message.filtersApplied">
                                <span class="filter-name">{{ f.filter_name }}:</span>
                                <span class="filter-values">{{ f.filter_values.join(', ') }}</span>
                              </div>
                            </div>
                          </div>
                          </div>
                        </div>
                      </div>
                      <div class="message-time">{{ message.timestamp | utcDateTime }}</div>
                    </div>
                  </div>
                  </ng-container>

                  <div *ngIf="isCurrentConversationPolling$ | async" class="typing-indicator">
                    <div class="nova-vector">
                      <img
                        src="assets/icons/navigator/nova-loading-animation.gif"
                        alt="loading animation">
                    </div>
                    <span class="typing-text">{{ (currentStep$ | async) || "Give me a moment, I'm looking it up..." }}</span>
                  </div>
                </div>
              </div>

              <!-- Show initial state (welcome message + suggestion cards) when no messages exist -->
              <div class="initial-state" *ngIf="shouldShowInitialState()">
                <div class="welcome-section">
                  <span class="welcome-text">Ask me Anything</span>
                  <span class="welcome-subtext">Navigate Knowledge with Confidence</span>
                </div>

                 <app-nova-suggestion
                   (suggestionSelected)="sendSuggestion($event)">
                 </app-nova-suggestion>
              </div>

            </div>

            <!-- Input section is hidden when Saved Files view is active -->
            <app-nova-input
              *ngIf="!showSavedFiles"
              [(messageText)]="messageText"
              [(attachments)]="attachments"
              (sendMessage)="sendMessage()"
              (keyDown)="onKeyDown($event)">
            </app-nova-input>
          </div>

        </div>
      </div>
    </div>
  </div>

  <!-- Image Viewer Overlay -->
  <div class="image-viewer-overlay" *ngIf="showImageViewer" (click)="$event.stopPropagation()">
    <div class="image-viewer-content" (click)="$event.stopPropagation()">
      <button class="close-btn" (click)="closeImageViewer()" title="Close">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 6L6 18M6 6L18 18" stroke="#475258" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <!-- Show iframe for HTML charts -->
      <div class="viewer-iframe-container" *ngIf="viewerIsHtml && viewerImageUrl">
        <iframe [src]="getSafeUrlForViewer(viewerImageUrl)" class="viewer-iframe" (load)="removePlotlyToolbarFromViewer($event)"></iframe>
      </div>
      <!-- Show image for regular images -->
      <img *ngIf="!viewerIsHtml && viewerImageUrl" [src]="viewerImageUrl" [alt]="viewerImageAlt" class="viewer-image">
    </div>
  </div>

  <!-- Delete Confirmation Dialog -->
  <div class="delete-confirmation-overlay" *ngIf="showDeleteConfirmation$ | async" (click)="cancelDelete()">
    <div class="delete-confirmation-dialog" (click)="$event.stopPropagation()">
      <div class="dialog-header">
        <img class="warning-icon" src="../../../assets/icons/navigator/delete-icon-red.svg"/>
        <span class="dialog-title">Confirm Deletion?</span>
      </div>
      <div class="dialog-content">
        <p>Are you sure you want to delete the conversation?</p>
      </div>
      <div class="dialog-actions">
        <button class="delete-btn" (click)="confirmDelete()">Delete</button>
        <button class="cancel-btn" (click)="cancelDelete()">Cancel</button>
      </div>
    </div>
  </div>
</div>
